import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import type { FormControl, FormGroup } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { Store } from '@ngrx/store';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import { TellentAppsDataFacade } from '@core/tellent-logic';
import { MEMBER_LISTED_ONLY, SeatKind } from '@core/tellent-types';
import {
  CheckboxComponent,
  ProtectedControlDirective,
  SelectComponent,
} from '@core/user-interface-legacy';

import { AtsLogoComponent } from '../../ats-logo/ats-logo.component';
import { HrLogoComponent } from '../../hr-logo/hr-logo.component';
import { JaveloLogoComponent } from '../../javelo-logo/javelo-logo.component';

export type SeatType = {
  toggle: FormControl<boolean | null>;
  appGuid: FormControl<string | null>;
  roleExternalId: FormControl<string | null>;
};

@Component({
  selector: 'tlc-access-roles-table',
  templateUrl: './access-roles-table.component.html',
  styleUrl: './access-roles-table.component.less',
  imports: [
    CheckboxComponent,
    JaveloLogoComponent,
    HrLogoComponent,
    SelectComponent,
    NgTemplateOutlet,
    ReactiveFormsModule,
    TranslatePipe,
    ProtectedControlDirective,
    AtsLogoComponent,
  ],
})
export class AccessRolesTableComponent {
  private readonly appsDataFacade = inject(TellentAppsDataFacade);

  public store = inject(Store);
  public i18n = inject(I18nService);

  public recruiteeFormGroup = input.required<FormGroup<SeatType>>();
  public kiwiFormGroup = input.required<FormGroup<SeatType>>();

  public recruiteeSelectOptions = this.appsDataFacade.rolesSelectOptions(SeatKind.Recruitment);

  public kiwiSelectOptions = this.appsDataFacade.rolesSelectOptions(SeatKind.CoreHR);

  public kiwiSelectOptionsWithMemberListed = computed(() => [
    ...this.kiwiSelectOptions(),
    this.getMemberListedOnlySelectOption(),
  ]);

  public isRecruiteeAvailable = this.appsDataFacade.appBySeatKind(SeatKind.Recruitment);

  public isKiwiAvailable = this.appsDataFacade.appBySeatKind(SeatKind.CoreHR);

  private getMemberListedOnlySelectOption() {
    return {
      label: this.i18n.translate('tlc.members.member_listed_only'),
      value: MEMBER_LISTED_ONLY,
    };
  }
}
